import styled from 'styled-components'
import {IoClose} from "react-icons/io5"

const Container = styled.div`
      border: 1px solid;
      padding: 7px 10px;
      border-color: ${({ theme }) => theme.mainBorderColor};
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-radius: 5px;
      color: ${({ theme }) => theme.mainTextColor};
      height: 42px;
      width: ${({width})=> width};
      
      input{
        font-size: 16px;
        font-weight: var(--font-weight-md);
        line-height: 12px;
        text-align: left;
        width: calc(100% - 25px);
        background-color: ${({ theme }) => theme.mainBgColor};
      }

      .icon{
        cursor: pointer;
      }

`
const SingleInputFilter = ({width, handleChange, name ,value, placeholder}) => {
  return (
    <Container width={width}>
      <input onChange={(e)=> handleChange(e.target.value)} name={name} value={value} placeholder={placeholder} />
      {
        value &&
      <IoClose onClick={() => handleChange("")} className='icon'/>
      }
    </Container>
  )
}

export default SingleInputFilter